import { createElement, forwardRef, type SVGProps } from 'react';
import type { LucideIcon } from 'lucide-react';

type ShareUserProps = SVGProps<SVGSVGElement> & {
  size?: string | number;
  absoluteStrokeWidth?: boolean;
};

const ShareUserIcon = forwardRef<SVGSVGElement, ShareUserProps>(
  (
    {
      color = 'currentColor',
      size = 24,
      strokeWidth = 2,
      absoluteStrokeWidth,
      className,
      ...props
    },
    ref,
  ) =>
    createElement(
      'svg',
      {
        ref,
        xmlns: 'http://www.w3.org/2000/svg',
        width: size,
        height: size,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: color,
        strokeWidth: absoluteStrokeWidth
          ? (Number(strokeWidth) * 24) / Number(size)
          : strokeWidth,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        className: ['lucide', 'lucide-share-user', className].filter(Boolean).join(' '),
        ...props,
      },
      createElement('circle', { cx: '6', cy: '9', r: '2.5' }),
      createElement('path', { d: 'M2.5 16.5c0-2 1.6-3.5 3.5-3.5s3.5 1.5 3.5 3.5' }),
      createElement('circle', { cx: '18', cy: '5', r: '3' }),
      createElement('circle', { cx: '18', cy: '19', r: '3' }),
      createElement('line', { x1: '8.59', x2: '15.42', y1: '13.51', y2: '17.49' }),
      createElement('line', { x1: '15.41', x2: '8.59', y1: '6.51', y2: '10.49' }),
    ),
);

ShareUserIcon.displayName = 'ShareUser';

export const ShareUser = ShareUserIcon as LucideIcon;
